import { useState, useEffect } from 'react';
import CONSTANTS from "../constants/constants";


export default function useMyTrueStoriesData(updater) {
  let customerId  = '';
  if (window.theme) {
    customerId = window.theme.customer.id;
  } else {
    customerId = window.ogShopifyConfig.customer.id;
  }
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const [ stories, setStories ] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetch(`${CONSTANTS.baseUrl}api/truestories/my-true-stories/${customerId}`)
      .catch(err => setError(err))
      .then(res => res.json())
      .then(response => {
        setStories(response.data);
        setLoading(false);
      });
  }, [ customerId, updater ]);

  return [ loading, error, stories ];
}
